import { render, staticRenderFns } from "./XieYiMobile.vue?vue&type=template&id=7c665794&"
import script from "./XieYiMobile.vue?vue&type=script&lang=js&"
export * from "./XieYiMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports